import { queryClient } from 'App';

/**
 * Live transaction update. The backend pushes a `transaction-create` over the
 * practice socket whenever a transaction is processed. We merge it straight into
 * the cached transaction lists with setQueriesData — NO refetch / no extra
 * backend request. Transaction list caches share the `{ transactions, count }`
 * shape and their query keys all contain "transaction" (e.g. 'transactions',
 * 'billing-transactions').
 */
export default async (data) => {
  const transaction = data?.transaction;
  if (!transaction?.id) return;

  queryClient.setQueriesData(
    {
      predicate: (query) =>
        Array.isArray(query.queryKey) &&
        query.queryKey.some(
          (key) => typeof key === 'string' && key.toLowerCase().includes('transaction')
        )
    },
    (oldData) => {
      if (!oldData || !Array.isArray(oldData.transactions)) return oldData;

      const exists = oldData.transactions.some((t) => t?.id === transaction.id);
      const transactions = exists
        ? oldData.transactions.map((t) => (t?.id === transaction.id ? { ...t, ...transaction } : t))
        : [transaction, ...oldData.transactions];

      return {
        ...oldData,
        transactions,
        count: exists ? oldData.count : (oldData.count ?? 0) + 1
      };
    }
  );
};
